import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { LangProvider } from "@/i18n";
import { ContentProvider } from "@/content/ContentContext";
import AdminPage from "@/pages/AdminPage";
import EditLayer from "@/admin/EditLayer";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Intro from "@/components/Intro";
import HomePage from "@/pages/HomePage";
import MenuPage from "@/pages/MenuPage";
import ServiziPage from "@/pages/ServiziPage";

export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ContentProvider>
      <LangProvider>
        <BrowserRouter>
          <div className="App">
            <div className="grain" aria-hidden="true" />
            <Intro />
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/servizi" element={<ServiziPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
            <Footer />
            <WhatsAppFab />
            <EditLayer />
          </div>
        </BrowserRouter>
      </LangProvider>
    </ContentProvider>
  );
}

export default App;
